<template>
  <div>
    <p class="tips">( 提示：设置白名单之后， Lucky 提现不受限制， 可提取所有Lucky )</p>
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="AddGalex">添加</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :model="formInline">
      <el-form-item label="用户名">
        <el-input size="small" v-model="formInline.address" placeholder="输入用户名"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表  show-summary :summary-method="getSummaries"  -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" prop="address" label="用户名">
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="onDisable(scope.row)">删除</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="创建时间">
      </el-table-column>
      
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 添加Galex -->
    <el-dialog title="添加" :visible.sync="addGalexVisible" width="50%"
      @click="addGalexVisible = false">
      <el-form label-width="90px" :model="editForm" :rules="Rules" ref="editForm">
        
        <el-form-item label="用户名" prop="address">
          <el-input size="small" v-model="editForm.address" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addGalexVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitUser('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { LWithdrawWhiteList, AddLWithdrawWhiteList , DelLWithdrawWhiteList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      // rules表单验证
      formInline: {
        from: 1,
        limit: 10,
        "address": ""
      },
      addGalexVisible: false,
      editForm: {
        "address": ""
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      Rules: {
        address: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
      },
      typeToken:[
        {name:'股东',value:'primary'},
        {name:'合伙人',value:'partner'}
      ],
      typeToken1:[
        {name:'默认',value:''},
        {name:'股东',value:'primary'},
        {name:'合伙人',value:'partner'}
      ]
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      LWithdrawWhiteList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },

    //Galex显示编辑界面
    AddGalex() {
      this.editForm = {
        "address": "",
      }
      this.addGalexVisible = true
    },
    // 添加
    submitUser(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // console.log(this.editForm)
          this.loading = true
          AddLWithdrawWhiteList(this.editForm)
            .then(res => {
              this.loading = false
              this.addGalexVisible = false
              if (res.code == 0) {
                console.log(res)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            }).catch(err => {
              this.addGalexVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
        }
      })
    },

    onDisable(row) {
        this.$confirm('是否删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          DelLWithdrawWhiteList({ address: row.address }).then(res => {
            this.loading = false
            if (!res || res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getdata(this.formInline)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      
    },
   
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage - 1) * (this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.formInline.from = 1
      this.getdata(this.formInline)
    }
  }
}
</script>
  
<style scoped>
.user-search {
  margin-top: 20px;
}
.tips{
  color: #666;
  font-size: 13px;
}
.userRole {
  width: 100%;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/lucky/WhiteList.vue